import { useEffect, useRef, useState } from "react";
import { http } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Search, X } from "lucide-react";

// Selettore cliente ricercabile collegato all'ID del contatto (no digitazione libera del nome).
// value = { contact_id, salon_name } · onChange riceve lo stesso shape.
export function ClientSelect({ value, onChange, testid = "client-select" }) {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { user } = useAuth() || {};
  const endpoint = user?.role === "AGENT" ? "/crm/me/contacts" : "/crm/contacts";

  useEffect(() => {
    http.get(endpoint).then((r) => setAll(r.data || [])).catch(() => setAll([]));
  }, [endpoint]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const filtered = (q.trim()
    ? all.filter((c) => `${c.commercial_name} ${c.company_name || ""} ${c.vat || ""}`.toLowerCase().includes(q.toLowerCase()))
    : all).slice(0, 8);
  const selected = value?.contact_id ? all.find((c) => c.id === value.contact_id) : null;
  const label = selected?.commercial_name || value?.salon_name;

  return (
    <div className="relative" ref={ref} data-testid={testid}>
      {label ? (
        <div className="flex items-center gap-2 px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }}>
          <span className="text-sm flex-1 truncate" data-testid={`${testid}-value`}>{label}{selected?.vat ? ` · ${selected.vat}` : ""}</span>
          <button type="button" onClick={(e) => { e.preventDefault(); onChange({ contact_id: null, salon_name: "" }); }} data-testid={`${testid}-clear`} aria-label="Rimuovi"><X className="w-4 h-4 text-neutral-400" /></button>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-2 px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }}>
            <Search className="w-4 h-4 text-neutral-400 shrink-0" />
            <input value={q} onFocus={() => setOpen(true)} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
              placeholder="Cerca cliente registrato…" data-testid={`${testid}-input`} className="w-full text-sm outline-none bg-transparent" />
          </div>
          {open && (
            <div className="absolute z-20 left-0 right-0 mt-1 bg-white border rounded-md shadow-lg max-h-56 overflow-y-auto" style={{ borderColor: "var(--border-silver)" }} data-testid={`${testid}-options`}>
              {filtered.length === 0 ? (
                <div className="px-3 py-2 text-xs text-neutral-400">Nessun cliente trovato. Crea prima il contatto in "Contatti e clienti".</div>
              ) : filtered.map((c) => (
                <button type="button" key={c.id} data-testid={`${testid}-opt-${c.id}`} onClick={(e) => { e.preventDefault(); onChange({ contact_id: c.id, salon_name: c.commercial_name }); setOpen(false); setQ(""); }}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-neutral-50">
                  {c.commercial_name}{c.vat ? <span className="text-neutral-400"> · {c.vat}</span> : ""}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
